import { ITrackingStatus, TTrackingMethod, TTrackingState } from 'types'
import { ITrackingOverview } from 'types/graphqlTypes'

type TTrackingOverview =
  | Pick<ITrackingOverview, 'trackingState' | 'calculatedTrackingMethod'>
  | undefined

export const getTrackingStatus = (
  trackingOverview: TTrackingOverview
): ITrackingStatus | undefined => {
  return (
    trackingOverview && {
      trackingState: trackingOverview?.trackingState as TTrackingState,
      trackingMethod: (['mobile', 'fms_mobile'].includes(trackingOverview?.calculatedTrackingMethod)
        ? 'APP'
        : 'ELD') as TTrackingMethod,
    }
  )
}
